module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/img_family-dd0a7007b7d54bb8c9b9e8658fa38507.png";